import { Light } from 'react-syntax-highlighter';
import schoolBook from 'react-syntax-highlighter/dist/cjs/styles/hljs/school-book';
import js from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import css from 'react-syntax-highlighter/dist/cjs/languages/hljs/css';
import xml from 'react-syntax-highlighter/dist/cjs/languages/hljs/xml';
import bash from 'react-syntax-highlighter/dist/cjs/languages/hljs/bash';
import json from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
export var initializeSyntaxHighlights = function () {
    var registerLanguage = Light.registerLanguage;
    registerLanguage('javascript', js);
    registerLanguage('css', css);
    registerLanguage('xml', xml);
    registerLanguage('bash', bash);
    registerLanguage('json', json);
};
export var getSyntaxHighlightStyle = function () {
    return schoolBook;
};
export var SyntaxHighlighter = Light;
//# sourceMappingURL=index.js.map